import { createFileRoute } from "@tanstack/react-router";
import { OrganizationDetailsPage } from "@/pages/organization-details";
import { searchParams } from "@/pages/organization-details/model/search-params";

export const Route = createFileRoute(
  "/_authed/$companySlug/organisations/$organizationId/",
)({
  component: OrganizationDetailsPage,
  validateSearch: searchParams,
});
